import { TickLabelProps } from '@visx/axis';

export const tickLabelProps: TickLabelProps<number> = {
  fill: '#AEAEB2',
  fontSize: 12,
};
